/** Per-item preselect for Next show mode when this cue becomes Next. */
export const PLAYLIST_NEXT_SHOW_MODES = ['inherit', 'mediaOnly', 'both', 'speakerOnly'] as const;

export type PlaylistNextShowMode = (typeof PLAYLIST_NEXT_SHOW_MODES)[number];

export const DEFAULT_PLAYLIST_NEXT_SHOW_MODE: PlaylistNextShowMode = 'inherit';

export type ExplicitPlaylistNextShowMode = Exclude<PlaylistNextShowMode, 'inherit'>;
